// extracted by mini-css-extract-plugin
export default {"toolbarControls":"ToolbarControls_toolbarControls__SdA2X"};